import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import LegalNotice from '@/pages/LegalNotice'
import TermsOfSale from '@/pages/TermsOfSale'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import Success from '@/pages/Success'
import { useRoutes } from 'react-router-dom'
import { CartProvider } from '@/context/CartContext'
import { LanguageProvider } from '@/context/LanguageContext'
import { usePageTracking } from '@/hooks/usePageTracking'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/legal-notice', element: <LegalNotice /> },
  { path: '/terms-of-sale', element: <TermsOfSale /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/success', element: <Success /> },
]

function AppRoutes() {
  usePageTracking()
  return useRoutes(routes)
}

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <AppRoutes />
      </CartProvider>
    </LanguageProvider>
  )
}

export default App
